import { Link } from "@StarberryUtils"
import React, { useState, useEffect } from "react"
import { Container, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import ScrollAnimation from 'react-animate-on-scroll';
// Style
import './CaseStudies.scss';
import ReactMarkdown from "react-markdown"
import { useStaticQuery, graphql } from "gatsby";
import moment from "moment"
import { BLOGS_PAGE_URL } from "@Components/common/site/constants";
import ImageRenderer from "@Components/ImageRenderer/ImageRenderer"
import GetURL from '@Components/common/site/get-url';
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
const CaseStudies = (props) => {
  const data = useStaticQuery(graphql`
  query {
    glstrapi {
      caseStudiesAndInsights(publicationState: LIVE, limit: 3, sort: "Date:desc") {
            id
            imagetransforms
            Date
            Title
            URL
            ggfx_results {
              transforms
              src_url
              src_cftle
            }
            Tile_Image {
                url
                alternativeText
            }
          }
        }
      }
    `);

  const [renderComponent, setRenderComponent] = useState(false);
  React.useEffect(() => {

    window.addEventListener("mousemove", () => {
      if (renderComponent === false) {
        setRenderComponent(true)
      }
    })
    window.addEventListener("touchmove", () => {
      if (renderComponent === false) {
        setRenderComponent(true)
      }
    })
    window.addEventListener("keypress", () => {
      if (renderComponent === false) {
        setRenderComponent(true)
      }
    })
  }, [])

  const settings = {
    dots: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    mobileFirst: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true
        }
      }
    ]


  }
  return (
    <div className="case-studies">
      <Container>
        <Row>
          <Col>
            <div className="case-studies-block">
              {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true}> */}
              <div className="case-studies-content">
                <h2 className="">{props.Title}</h2>
                <div className="rich-text-editer-block">
                  <ReactMarkdown source={props.Content} allowDangerousHtml />
                </div>
              </div>
              {/* </ScrollAnimation> */}
              <div className="case-studies-list slick-pagination">
                {props.View_More != null && props.View_More?.CTA_1_URL &&
                  <div className="view-more-wrap">
                    <GetURL isLinkArrow="true" label={props.View_More.CTA_1_Label} alias={props.View_More.CTA_1_URL.Alias} class={'link-text'} />
                  </div>
                }
                <Slider {...settings} >
                  {data.glstrapi.caseStudiesAndInsights.map((node, index) => {
                    let processedImages = JSON.stringify({});
                    if (node?.imagetransforms?.Image_Transforms) {
                      processedImages = node.imagetransforms.Image_Transforms;
                    }
                    let altTextVal = node?.Tile_Image?.alternativeText ? node?.Tile_Image?.alternativeText : node?.Title
                    return (

                      <div className="case-studies-news img-zoom">
                        {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true}> */}
                        <div className={index === 1 ? "case-studies-img middle" : "case-studies-img"}>
                          <Link to={BLOGS_PAGE_URL.alias + '/' + node.URL}>
                            {renderComponent &&
                              <ImageRenderer ImageSrc={node?.Tile_Image} altText={altTextVal + ' - Bentley Hurst'} ggfx_results={node.ggfx_results} strapi_id={node?.id} imagename='case-studies-and-insights.Image.homepage' />
                            }

                          </Link>
                        </div>
                        <div className="case-studies-title">
                          <h3><Link to={BLOGS_PAGE_URL.alias + '/' + node.URL}>{node.Title}</Link></h3>
                          <span>{moment(node.Date).format('DD MMMM YYYY')}</span>
                        </div>
                        {/* </ScrollAnimation> */}
                      </div>
                    )
                  })
                  }


                </Slider>

              </div>


            </div>

          </Col>
        </Row>
      </Container>
    </div>
  )
}



export default CaseStudies